import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import { EducationFields } from './EducationFields';
import { FinancialInstrumentsFields } from './FinancialInstrumentsFields';
import { FutureOperationsFields } from './FutureOperationsFields';
import { Section } from './Section';

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={48} spacingMobile={36}>
      <Section title={t('onboarding.knowledgeAndExperience.education.title')}>
        <EducationFields />
      </Section>

      <Section
        title={t(
          'onboarding.knowledgeAndExperience.financialInstruments.title'
        )}
      >
        <FinancialInstrumentsFields />
      </Section>

      <Section
        title={t('onboarding.knowledgeAndExperience.futureOperations.title')}
      >
        <FutureOperationsFields />
      </Section>
    </Stack>
  );
};
